<form [formGroup]="fg" class="form-inline" novalidate (ngSubmit)="onSubmitForm()">

    <div class="row content-page">
        <div class="col-md-7 col-md-offset-2 optin-container">
            <h1>Contact Preferences</h1>

            <p>&nbsp;</p>
            <p>As a ProClub member, not only will you have access to the benefits of the ProClub membership, the ProClub website and ProClub app, Adey will also provide you with a variety of topical and interesting information on a regular basis. This is your chance to let us know what information you would like to receive and how you would like to receive it.</p>
            <p>&nbsp;</p>

            <p>I'd like to get information about Adey's goods, services or events that may be of interest to me.</p>

            <mat-checkbox md-no-ink class="md-primary" formControlName="optIn">
                Yes, please contact me
            </mat-checkbox>

            <p>&nbsp;</p>

            <p>If you don't want to receive anything, just leave the above tick boxes blank. If you do want to hear about any of the above you can change your mind at any point, ask us to stop contacting you, and we will do so without delay. Rest assured, all personal data we collect is held in accordance with our Privacy Policy, a copy of which can be found here <a href="https://www.adey.com/privacy-policy" title="Privacy Policy">https://www.adey.com/privacy-policy</a></p>
            <p>&nbsp;</p>

            <input type="submit" class="btn btn-primary feature-btn branding-color-white branding-background-adey-blue" value="Save Preferences" />
        </div>
    </div>
</form>

